import React from "react";
import ParentEventView from "./ParentEventView";
import ChildEventView from "./ChildEventView";

class EventView extends React.Component {
    render() {
        if (this.props.childTrackIndex === false) {
            return (
                <ParentEventView
                    index={this.props.index}
                    event={this.props.event}
                    parentTrackIndex={this.props.parentTrackIndex}
                    childTrackIndex={this.props.childTrackIndex}
                    dragStart={this.props.dragStart}
                    dragEnd={this.props.dragEnd}
                    dragging={this.props.dragging}
                    dragTimeBlockIndex={this.props.dragTimeBlockIndex}
                    dragTimeBlockRow={this.props.dragTimeBlockRow}
                    movingEventIndex={this.props.movingEventIndex}
                    selected={this.props.selected === this.props.index}
                    showChildren={this.props.showChildren}
                />
            );
        } else {
            return (
                <ChildEventView
                    index={this.props.index}
                    event={this.props.event}
                    parentTrackIndex={this.props.parentTrackIndex}
                    childTrackIndex={this.props.childTrackIndex}
                    dragStart={this.props.dragStart}
                    dragEnd={this.props.dragEnd}
                    dragging={this.props.dragging}
                    dragTimeBlockIndex={this.props.dragTimeBlockIndex}
                    dragTimeBlockRow={this.props.dragTimeBlockRow}
                    movingEventIndex={this.props.movingEventIndex}
                    selected={this.props.selected === this.props.index}
                />
            );
        }
    }
}

export default EventView;
